<template lang="html">

  <div class="card-container newOrder">
      <breadcrumb :nameSection = 'nameSection' :listRoutes = 'listRoutes'></breadcrumb>
      <div class="" v-if="!dataOriginal">
        <!--<circle-spin ></circle-spin>-->
      </div>
      <div class="step_container" v-if="dataOriginal">

        <ul class="progressbar">

          <li id="li1" href="#" :class="{ inprocess : state1 === 1 , active: state2 === 1 || state2 === 2}" @click="changeFormView(1)">
            <p>Datos del embarque</p>
          </li>

          <li id="li2" :class="{inprocess: state2 === 1, active: state3 === 1 || state3 === 2 || dataLocal.dataShipment.status, disabled: state1 === 1 && !dataLocal.dataShipment.status}" @click="changeFormView(2)">
            <p>Agregar equipaje</p>
          </li>

          <li id="li3" :class="{inprocess: state3 === 1, active: state4 === 1 || state2 === 1 ||  dataLocal.dataShipment.status, disabled: state1 === 1 && !dataLocal.dataShipment.status  }"
             @click="changeFormView(3)">
            <p>Agregar órdenes</p>
          </li>

          <li id="li4" :class="{inprocess: state4 === 1 ,active: dataLocal.dataOrder.status, disabled: (state1 ===1 || state2 === 1 || state3 ===1) && !dataLocal.dataOrder.status }" @click="changeFormView(4)">
            <p>Embarcar</p>
          </li>

        </ul>

      </div>
      <div v-if="dataOriginal">
        <form1 v-if="state1 == 1" v-bind:idOperator="idOperator" v-bind:dataLocal="dataLocal" @toNextForm = "toSecondForm" @saveOk= "setSaveOk"></form1>
        <form2 v-if="state2 == 1" v-bind:id="dataOriginal.id" v-bind:dataLocal="dataLocal" @toNextForm = "toThirdForm" @updateListLuggage = "updateListLuggage"></form2>
        <form3 v-if="state3 == 1" v-bind:id="dataOriginal.id" v-bind:dataLocal="dataLocal"  @go-toForm4="gotoForm4" @packages-saved="packagesSaved" @total-weight-updated="updateTotalWeight"></form3>
        <form4 v-if="state4 == 1"  v-bind:id="dataOriginal.id" v-bind:dataLocal="dataLocal" v-bind:totalWeightLb="totalWeightLb"  @toSendForm = "toSendForm"></form4>
      </div>

  </div>
</template>

<script>
import form1 from '@/components/prefab/elements/form-1-create-shipment'
import form2 from '@/components/prefab/elements/form-2-create-shipment'
import form3 from '@/components/prefab/elements/form-3-create-shipment'
import form4 from '@/components/prefab/elements/form-4-create-shipment'

import { shipmentService } from '@/services/shipment.service'
import breadcrumb from '@/components/prefab/structures/breadcrumb.vue'
export default {
  components: {
    form1,
    form2,
    form3,
    form4,
    breadcrumb
  },
  props: [
    'idShipment'
  ],
  data() {
    return {
      state1: 1,
      state2: 0,
      state3: 0,
      state4: 0,
      saveOk: false,
      totalWeightLb: null,
      idOperator: '',
      dataOriginal: null,
      dataLocal: {
        dataShipment: {
          status: false,
          description: 'qwerty',
          departure_date: '2019-05-12',
          arrival_date: '2019-06-15',
          destination_id: 22,
          creator_operator_id: 52,
          reciever_operator_id: 202
        },
        dataLuggage: { status: true },
        dataOrder: { status: true }
      },

      nameSection: 'Crear embarque',
      listRoutes: [
        { nameRoute: 'shipments-list', titleRoute: 'Embarques' },
        { nameRoute: 'shipments-create', titleRoute: 'Crear embarque' }
      ]
    }
  },
  created() {
    window.addEventListener('beforeunload', this.setWindowListener)
    this.fetchData()
  },
  methods: {
    setSaveOk(flag) {
      this.saveOk = flag
    },
    setWindowListener(event) {
      console.log('Estamos en setWindoesListener')
      if (this.onCreateBasicBoarding){

        event.returnValue = 'Write something'
      }

    },
    fetchData() {
      // La información sensible no debe estar en el localstorage
      //this.idOperator = JSON.parse(window.localStorage.getItem('user')).id
      this.idOperator = this.$store.state.user.id;
      // Seleccionó un embarque?
      if (this.idShipment) {
        // Update
        this.state1 = 1
        this.state2 = 0
        this.state3 = 0
        this.state4 = 0
        //console.log('Va a llamar el get shipment detail')
        shipmentService.getShipmentDetail(parseInt(this.idShipment), this.getDataOriginal)
        //console.log('Termino de llamarlo')
      } else {
        // Create
        this.parseDataOriginal()
      }
    },
    changeFormView(event) {
      if (event == 1) {
        this.state1 = 1
        this.state2 = 0
        this.state3 = 0
        this.state4 = 0
      } else if (event == 2) {
        this.state1 = 2
        this.state2 = 1
        this.state3 = 0
        this.state4 = 0
      } else if (event == 3) {
        this.state1 = 2
        this.state2 = 2
        this.state3 = 1
        this.state4 = 0
      } else if (event == 4) {
        this.state1 = 2
        this.state2 = 2
        this.state3 = 2
        this.state4 = 1
      }
    },
    // Actualiza dataOriginal y dataLocal después de haber creado el embarque
    toSecondForm(dataCopy, dataOriginal) {
      if (dataCopy.status) {
        this.dataLocal.dataShipment = dataCopy
        if (dataOriginal) {
           this.dataOriginal = dataOriginal;
        }
        // Renderiza el component
        this.$router.push({
          name: 'shipments-edit',
          params: { id: dataOriginal.id }
        })
        shipmentService.getShipmentDetail(parseInt(dataOriginal.id),this.getDataOriginal)
         // this.changeFormView(2)
      }
    },
    toThirdForm(dataCopy) {
      if (dataCopy.status) {
        this.dataLocal.dataLuggage = dataCopy
        this.changeFormView(3)
      }
    },
    async toSendForm(flag) {
      let id = this.idShipment
      if (!id) {
        id = this.dataOriginal.id
      }
      if (flag) {
        let aux
        aux = await shipmentService.changeStateShipment(id, 'true')
        if (!aux) {
          alert('error al cambiar de estado')
          return
        }
        if (aux.attributes.status == 2) {
          this.$router.push({ name: 'shipments-show', params: { id: id } })
        }
      }
    },
    updateTotalWeight(total) {
      this.totalWeightLb = total
    },
    updateListLuggage(itemLuggage) {
      if (itemLuggage) {
        this.dataOriginal.attributes.luggage_items.push(itemLuggage)
        this.parseDataOriginal()
      }
    },
    getDataOriginal(data) {
      console.log('Método: getDataOriginal y obtuvimos estos datos del embarque')
      console.log(data)
      this.dataOriginal = data
      this.parseDataOriginal()
    },
    gotoForm4(){
      this.changeFormView(4)
    },
    packagesSaved() {
      console.log('Se guardaron los paquetes refrescamos todo el componente')
      this.fetchData()
      //this.changeFormView(4)
      this.changeFormView(3)
    },
    parseDataOriginal() {
      // Parsear datos si se seleccionó un embarque
      if (this.dataOriginal) {
        this.dataLocal = new Object()
        this.dataLocal.dataShipment = new Object()
        this.dataLocal.dataShipment.status = true
        this.dataLocal.dataShipment.description = this.dataOriginal.attributes.description
        this.dataLocal.dataShipment.departure_date = this.dataOriginal.attributes.departure_date
        this.dataLocal.dataShipment.arrival_date = this.dataOriginal.attributes.arrival_date
        this.dataLocal.dataShipment.destination_id = this.dataOriginal.attributes.destination_id
        this.dataLocal.dataShipment.destination = this.dataOriginal.attributes.destination
        this.dataLocal.dataShipment.creator_operator_id = this.dataOriginal.attributes.creator_operator_id
        this.dataLocal.dataShipment.creator_operator = this.dataOriginal.attributes.creator_operator
        this.dataLocal.dataShipment.reciever_operator_id = this.dataOriginal.attributes.reciever_operator_id
        this.dataLocal.dataShipment.reciever_operator = this.dataOriginal.attributes.reciever_operator

        //Verifica si existen items en el equipaje del embarque sino lo deja como vacío
        if (
          this.dataOriginal.attributes.luggage_items != null &&
          this.dataOriginal.attributes.luggage_items.length
        ) {
          this.dataLocal.dataLuggage = new Object()
          this.dataLocal.dataLuggage.status = true
          this.dataLocal.dataLuggage.luggage_items = this.dataOriginal.attributes.luggage_items
        } else {
          this.dataLocal.dataLuggage = new Object()
          this.dataLocal.dataLuggage.status = false
          this.dataLocal.dataLuggage.luggage_items = []
        }

        //Verifica si existe orden de compras sino lo deja como vacío
        if (
          this.dataOriginal.attributes.packages != null &&
          this.dataOriginal.attributes.packages.length
        ) {
          this.dataLocal.dataOrder = new Object()
          this.dataLocal.dataOrder.status = true
          this.dataLocal.dataOrder.packages = this.dataOriginal.attributes.packages
          console.log(this.dataLocal.dataOrder.packages)
          this.totalWeightLb = 0
          this.dataLocal.dataOrder.packages.forEach(pack => {
            console.log(pack.attributes.partial_weigth);
            this.totalWeightLb+= pack.attributes.partial_weight
          });
          this.dataLocal.dataLuggage.luggage_items.forEach(pack => {
            console.log(pack.attributes.weight);
            this.totalWeightLb+= pack.attributes.weight
          });
          // console.log(totalWeigthLb)
          // this.totalWeightLb = totalWeightLb
          console.log(this.totalWeightLb)
          console.log("***************************");
        } else {
          this.dataLocal.dataOrder = new Object()
          this.dataLocal.dataOrder.status = false
          this.dataLocal.dataOrder.packages = []
        }
      // Si no se seleccionó un embarque
      } else {
        this.dataOriginal = 'waiting'
        this.dataLocal = {
          dataShipment: {
            status: false,
            creator_operator_id: this.idOperator
          },
          dataLuggage: {
            status: false
          },
          dataOrder: {
            status: false
          }
        }
      }
    }
  },
  beforeDestroy: function() {
    window.removeEventListener('beforeunload', this.setWindowListener)
  },
  beforeRouteLeave(to, from, next) {
    let askFlag = true
    if (document.readyState == 'loading') {
      askFlag = false
    } else if (document.readyState == 'complete') {
      askFlag = !this.saveOk
    }

    if (askFlag && this.onCreateBasicBoarding) {
      const answer = window.confirm(
        'No se han guardado los cambios, ¿está seguro de salir?'
      )
      if (answer) {
        next()
        return
      } else {
        next(false)
        return
      }
    }
    next()
  },
  computed:{
    onCreateBasicBoarding(){
      return !this.dataLocal.dataShipment.status && this.state1 == 1 && this.state2==0 && this.state3 == 0 && this.state4==0
    }
  }
}
</script>



// WEBPACK FOOTER //
// shipment-create-view.vue?550a9be8